export default __webpack_public_path__ + "static/media/480_private03-it-web.221e8849.png";